const initialState = {
  bcfligs: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "BCFrs_LIG_SELECT":
      return {
        ...state,
        bcfligs: action.payload,
      };
    default:
      return state;
  }
}
